import { Settings05Icon, ViewOffSlashIcon } from '@hugeicons-pro/core-stroke-rounded';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Card } from '@/components/gluestack/card';
import { HStack } from '@/components/gluestack/hstack';
import { Text } from '@/components/gluestack/text';
import { VStack } from '@/components/gluestack/vstack';
import { ButtonWrapper } from '@/components/ui/ButtonWrapper';
import { HugeIconsWrapper } from '@/components/ui/HugeIconsWrapper';
import { useIsLargeScreen } from '@/hooks/useIsLargeScreen';

interface ISensitivePhotosReminderCardProps {
  onOpenSettings: () => void;
  onDismiss: () => void;
}

export function SensitivePhotosReminderCard({
  onOpenSettings,
  onDismiss,
}: ISensitivePhotosReminderCardProps) {
  const { t } = useTranslation();
  const isLargeScreen = useIsLargeScreen();

  return (
    <Card size="lg" variant="outline" className="border-outline-100 bg-background-0 mb-2 -mt-2">
      <HStack className="items-start gap-3">
        {isLargeScreen ? (
          <VStack className="h-10 w-10 shrink-0 items-center justify-center rounded-full bg-background-200">
            <HugeIconsWrapper icon={ViewOffSlashIcon} size={22} className="color-typography-600" />
          </VStack>
        ) : null}

        <VStack className="min-w-0 flex-1 gap-3">
          <VStack className="gap-1">
            <Text bold className="text-typography-900">
              {t('photos.sensitiveReminder.title')}
            </Text>
            <Text size="sm" className="text-typography-600">
              {t('photos.sensitiveReminder.body')}
            </Text>
          </VStack>

          <HStack className="flex-wrap items-center gap-2">
            <ButtonWrapper
              icon={Settings05Icon}
              text={t('photos.sensitiveReminder.action')}
              size="sm"
              action="primary"
              onPress={onOpenSettings}
            />
            <ButtonWrapper
              text={t('photos.sensitiveReminder.dismiss')}
              size="sm"
              variant="outline"
              action="neutral"
              onPress={onDismiss}
            />
          </HStack>
        </VStack>
      </HStack>
    </Card>
  );
}
